import { keyBy } from 'lodash';

export const getTableDataFromMembershipAndShops = (membership, shops) => {
  const shopAssignees = membership.assignees.filter(a => a.assigneeType === 'shop');
  const assigneesById = keyBy(shopAssignees, 'assigneeId');

  return shops.map((shop) => {
    const assignment = assigneesById[shop.id];

    const shared = {
      name: shop.alias || shop.name,
      status: 'unassigned',
      counts: null,
      shopId: shop.id,
      canBeAssigned: true,
    };

    if (!assignment) {
      return shared;
    }

    return {
      ...shared,
      ...assignment,
      status: 'assigned',
      canBeAssigned: assignment.counts.active < 1,
    };
  });
};

export const isItemChanged = (item, assignments) => (
  (item.status === 'assigned' && !assignments[item.shopId])
  || (item.status === 'unassigned' && assignments[item.shopId])
);

export const getAssignmentPayload = (tableItems, assignments) => (
  tableItems
    .filter(item => isItemChanged(item, assignments))
    .map(item => ({
      assigneeId: item.shopId,
      assigneeType: 'shop',
      deleted: !assignments[item.shopId],
      name: item.name,
    }))
);

export const getUnassignedItemNames = items => (
  items
    .filter(i => i.deleted)
    .map(i => i.name)
    .join(', ')
);

export const getAssignedItemNames = items => (
  items
    .filter(i => !i.deleted)
    .map(i => i.name)
    .join(', ')
);

export const getShopAssignments = tableItems => (
  tableItems.reduce(
    (memo, item) => ({
      ...memo,
      [item.shopId]: item.status === 'assigned',
    }),
    {},
  )
);
